import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { COLOR_APP } from "constants/index";
import { TbError404 } from "react-icons/tb";

const NotFound: React.FC = () => {
  return (
    <div className="flex h-screen w-full flex-col items-center justify-center px-4">
      <div className="flex-3 flex flex-col justify-center items-center">
        <TbError404 className="w-100 h-50" />
        <div className="text-2xl font-bold">Page not found !</div>
        <Link to="/dashboard">
          <span className="text-xl">{">> back to home <<"}</span>
        </Link>
      </div>

      {/* spase */}
      <div className="flex-2" />
      {/* Footer section  ------------------------------------------------------------------------------------------ */}
      <div className="text-center text-sm opacity-70">
        COPYRIGHT © 2024 ONETOP SOLE.,LTD. ALL RIGHTS RESERVED.
      </div>
    </div>
  );
};

export default NotFound;
